<template>
  <div class="land-tlu">
    <h2 class="land-tlu-title">Выбрать район</h2>
    <div>
      <tree-component @myIdIs="setTreeId($event)" @setSelected="setSelected($event)" :inputData="regionList"/>
    </div>
    <button class="btn accent-btn tree-button" @click="acceptFilters()">Применить</button>
  </div>
</template>

<script>
import TreeComponent from '../tree/TreeComponent'
import { eventBus } from '@/main.js'

export default {
  name: 'region-list-component',
  components: {
    TreeComponent
  },
  data () {
    return {
      selectedRegionList: [],
      fullInfo: []
    }
  },
  computed: {
    regionList () {
      let _list = this.$store.getters.REGION_LIST
      if (_list === null) {
        return null
      }
      let arr = _list.okatoList.edges.map(item => {
        let a = {
          id: item.node.okato,
          parent: (item.node.parentCode !== null && item.node.parentCode !== '') ? item.node.parentCode : '#',
          text: item.node.text
        }
        // console.log(a)
        return a
      })
      arr.sort((a, b) => {
        let textA = a.text.toLowerCase()
        let textB = b.text.toLowerCase()
        if (textA < textB) return -1
        if (textA > textB) return 1
        return 0
      })
      return arr
    }
  },
  methods: {
    qwe () {
      console.log(this.$store.getters.REGION_LIST)
    },
    setTreeId (e) {
      this.$store.dispatch('SET_VALUE', {key: 'regionTreeId', value: e})
    },
    setSelected (e) {
      this.selectedRegionList = e.ids
      this.fullInfo = e.fullInfo
    },
    acceptFilters () {
      let _fullInfo = JSON.parse(JSON.stringify(this.fullInfo))
      let _selectedRegionList = JSON.parse(JSON.stringify(this.selectedRegionList))
      this.$store.dispatch('SET_IDS', {key: 'region', value: _fullInfo})
      eventBus.$emit('setLandListFilter', {key: 'region', value: _selectedRegionList})
      eventBus.$emit('setShowPopup', {key: 'region', value: false})
    }
  }
}
</script>

<style scoped lang="scss">
.land-tlu {
  width: 100%;
  height: 100%;
  padding: 20px 0 80px 40px;

  &-title {
    margin-bottom: 20px;
  }
}
.tree-button {
  position: absolute;
  right: 50px;
  bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/LandRegionVue.vue